export const playerGameStats = ({ players, playerStats }) => {
  return players.map(player => ({
    ...player,
    points: playerStats
      .filter(
        stat => stat.stat_type === "POINTS" && stat.player_id === player.id
      )
      .reduce((accum, value) => accum + parseInt(value.stat_value), 0),
    rebounds: playerStats
      .filter(
        stat =>
          (stat.stat_type === "OFFENSIVE_REBOUND" ||
            stat.stat_type === "DEFENSIVE_REBOUND") &&
          stat.player_id === player.id
      )
      .reduce((accum, value) => accum + parseInt(value.stat_value), 0),
    assists: playerStats
      .filter(
        stat => stat.stat_type === "ASSISTS" && stat.player_id === player.id
      )
      .reduce((accum, value) => accum + parseInt(value.stat_value), 0),
    personal_fouls: playerStats
      .filter(
        stat => stat.stat_type === "FOULS" && stat.player_id === player.id
      )
      .reduce((accum, value) => accum + parseInt(value.stat_value), 0),
    team_fouls: playerStats
      .filter(
        stat => stat.stat_type === "TEAM_FOULS" && stat.player_id === player.id
      )
      .reduce((accum, value) => accum + parseInt(value.stat_value), 0),
    blocks: playerStats
      .filter(
        stat => stat.stat_type === "BLOCKS" && stat.player_id === player.id
      )
      .reduce((accum, value) => accum + parseInt(value.stat_value), 0),
    steals: playerStats
      .filter(
        stat => stat.stat_type === "STEALS" && stat.player_id === player.id
      )
      .reduce((accum, value) => accum + parseInt(value.stat_value), 0),
    turnovers: playerStats
      .filter(
        stat => stat.stat_type === "TURNOVERS" && stat.player_id === player.id
      )
      .reduce((accum, value) => accum + parseInt(value.stat_value), 0),
    fgm: playerStats
      .filter(stat => stat.stat_type === "FGM" && stat.player_id === player.id)
      .reduce((accum, value) => accum + parseInt(value.stat_value), 0),
    fga: playerStats
      .filter(stat => stat.stat_type === "FGA" && stat.player_id === player.id)
      .reduce((accum, value) => accum + parseInt(value.stat_value), 0),
    ftm: playerStats
      .filter(stat => stat.stat_type === "FTM" && stat.player_id === player.id)
      .reduce((accum, value) => accum + parseInt(value.stat_value), 0),
    fta: playerStats
      .filter(stat => stat.stat_type === "FTA" && stat.player_id === player.id)
      .reduce((accum, value) => accum + parseInt(value.stat_value), 0),
    fgm3: playerStats
      .filter(stat => stat.stat_type === "FGM3" && stat.player_id === player.id)
      .reduce((accum, value) => accum + parseInt(value.stat_value), 0),
    fga3: playerStats
      .filter(stat => stat.stat_type === "FGA3" && stat.player_id === player.id)
      .reduce((accum, value) => accum + parseInt(value.stat_value), 0)
  }));
};

export const totalGamePeriodStats = ({
  playerStats,
  teamId,
  statType,
  periodType
}) => {
  return playerStats
    .filter(
      stat =>
        stat.stat_type === statType &&
        stat.team_id === teamId &&
        stat.period_type === periodType
    )
    .reduce((accum, value) => {
      return accum + parseInt(value.stat_value);
    }, 0);
};
